export { default as BookmarkIcon } from '~icons/mdi/bookmark';
